/* import __COLOCATED_TEMPLATE__ from './recurring-transfer-settings.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();